// import { Injectable } from "@angular/core";
// import {
//   ActivatedRouteSnapshot,
//   RouterStateSnapshot,
//   UrlTree,
//   Router,
//   CanActivateFn,
// } from "@angular/router";
// import { Observable } from "rxjs";
// import { inject } from "@angular/core";

// @Injectable({
//   providedIn: "root",
// })
// export class AuthGaurdGuard {
//   constructor(private router: Router) {}
//   canActivate: CanActivateFn = (
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot,
//   ):
//     | Observable<boolean | UrlTree>
//     | Promise<boolean | UrlTree>
//     | boolean
//     | UrlTree => {
//     if (
//       localStorage.getItem("guestToken") &&
//       localStorage.getItem("guestToken") != ""
//     ) {
//       return true;
//     } else {
//       console.log(
//         "token not found --> returning to login --> authguard",
//         localStorage.getItem("guestToken"),
//         localStorage.getItem("fcm_token"),
//       );
//       localStorage.setItem("redirectAfterLogin", window.location.href);
//       this.router.navigate(["/login"]);
//       return false;
//     }
//   };
// }

// auth-gaurd.guard.ts
// auth-guard.guard.ts
import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthService } from "./service/auth-service";
import { UserService } from "./service/user.service";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthGaurdGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) {}

  canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree => {

    if (this.authService.isLoggedIn()) {
      // After an Admin's password reset the person sets their own password before anything else (20 Oct 2026).
      if (localStorage.getItem("mustChangePassword") === "true" && !state.url.startsWith("/change-password")) {
        return this.router.createUrlTree(["/change-password"]);
      }
      // Check module-specific access if configured
      const requiredModule = route.data && route.data["module"];
      if (requiredModule) {
        // Hide WhatsApp module on test backend
        if (requiredModule === "WHATSAPP-BROADCAST" && environment.host.includes("backend-test")) {
          console.warn("Access denied: whatsapp-broadcast is disabled on test backend.");
          return this.router.createUrlTree(["/home"]);
        }

        const modulesStr = localStorage.getItem("modules") || "";

        // The login response does not carry the module list — it arrives from
        // the user detail call. An empty list therefore means "not loaded
        // yet", not "no access", and denying here sent anyone following a
        // deep link straight to /home.
        if (!modulesStr) {
          return this.resolveModuleAccess(requiredModule);
        }

        if (!this.hasModule(modulesStr, requiredModule)) {
          console.warn(`Access denied: User does not have access to ${requiredModule}`);
          return this.router.createUrlTree(["/home"]);
        }
      }
      return true;
    }

    console.log("AuthGuard → User not logged in or session expired, redirecting to /login");

    // Includes the query string, so a shared link like
    // /vault?folder=<id> reopens that folder after login.
    const redirectUrl = state.url;
    localStorage.setItem("redirectAfterLogin", redirectUrl);
    this.router.navigate(["/login"]);
    return false;
  };

  private hasModule(modulesStr: string, requiredModule: string): boolean {
    const userModules = modulesStr
      .split(",")
      .map((m) => m.trim().toUpperCase())
      .filter(Boolean);

    return userModules.includes(requiredModule.toUpperCase());
  }

  /**
   * Fetches the module list before deciding, for the window right after login
   * where nothing has stored it yet. Caches it so this only happens once.
   */
  private resolveModuleAccess(
    requiredModule: string
  ): Observable<boolean | UrlTree> {
    const guestID = localStorage.getItem("guestID");
    if (!guestID) return of(this.router.createUrlTree(["/home"]));

    return this.userService.getUserDetails(guestID).pipe(
      map((res: any) => {
        const modules = res?.data?.modules || res?.data?.moduleAccess;
        const modulesVal = Array.isArray(modules)
          ? modules.join(",")
          : modules || "";

        localStorage.setItem("modules", modulesVal);

        const subModulesData = res?.data?.subModules || res?.data?.subModuleAccess;
        if (subModulesData) {
          const subModulesVal = typeof subModulesData === 'object' ? JSON.stringify(subModulesData) : subModulesData;
          localStorage.setItem("subModules", subModulesVal);
        }

        if (this.hasModule(modulesVal, requiredModule)) return true;

        console.warn(
          `Access denied: User does not have access to ${requiredModule}`
        );
        return this.router.createUrlTree(["/home"]);
      }),
      catchError((err) => {
        console.error("AuthGuard → could not load user modules:", err);
        return of(this.router.createUrlTree(["/home"]));
      })
    );
  }
}
